import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-315c72f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "testimonial" }, null, -1))

import { marked } from 'marked'

/*
 * pass a text from a translation result - it can contain markdown syntax
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'CCustomerService',
  props: {
    text: {}
  },
  emits: ['customer'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit

function md(text: string) {
  return marked(text)
}
function clickHandler(e: Event) {
  const event: any = e

  if (event.target && event.target.tagName === 'A') {
    if (event.target.href && /#customer/.test(event.target.href)) {
      emit('customer')
    }
  }
  e.preventDefault()
}

return (_ctx: any,_cache: any) => {
  const _component_t_text = _resolveComponent("t-text")!

  return (_openBlock(), _createElementBlock("div", {
    class: "customer-service t-text",
    onClick: clickHandler,
    "data-qe-id": "customer-service-panel"
  }, [
    _hoisted_1,
    _createVNode(_component_t_text, {
      class: "content",
      innerHTML: md(_ctx.text)
    }, null, 8, ["innerHTML"])
  ]))
}
}

})